// src/pages/admin/AdminOrderManager.jsx
import React, { useEffect, useState } from 'react';
import '../styles/AdminOrderManager.css';
import AdminSidebar from "./AdminSidebar";

const AdminOrderManager = () => {
    const [orders, setOrders] = useState([]);
    const [newOrderAlert, setNewOrderAlert] = useState(false);

    useEffect(() => {
        const prepareSound = () => {
            const audio = new Audio('/sounds/notification.mp3');
            audio.play().then(() => {
                audio.pause();
                audio.currentTime = 0;
                console.log("🔊 사운드 준비 완료");
            }).catch(() => {
                console.log("⚠️ 유저 상호작용 전에는 사운드 재생이 제한됩니다");
            });

            window.removeEventListener('click', prepareSound);
        };

        window.addEventListener('click', prepareSound);
    }, []);

    // 브라우저 알림 권한 요청
    useEffect(() => {
        if (Notification.permission !== 'granted') {
            Notification.requestPermission().then(r => {});
        }

    }, []);

    // 새 주문 감지용 타이머
    useEffect(() => {
        // 페이지 로드 시 새 주문 체크
        fetchOrders();
        console.log('주문 체크' + orders);

        // 5분 간격으로 새 주문 체크
        const interval = setInterval(() => {
            fetchOrders();
            console.log('주문 체크' + orders);
        }, 300000); // 5분 간격 체크

        return () => clearInterval(interval);
    }, []);

    // 주문 목록 가져오기
    const fetchOrders = async () => {
        fetch('/api/admin/orders/new') // 새 주문만 가져오는 API
            .then(res => res.json())
            .then(data => {
                if (data.count > 0) {
                    setOrders(data.orders);
                    setNewOrderAlert(true);

                    // 브라우저 알림
                    if (Notification.permission === 'granted') {
                        new Notification('새 주문 알림', {
                            body: `${data.count}개의 새로운 주문이 도착했습니다.`,
                            icon: '/softcat2.ico'
                        });
                    }

                    // 사운드 재생
                    const audio = new Audio('/sounds/notification.mp3');
                    audio.play();
                }
            })
            .catch(err => console.error('주문 불러오기 실패', err));
    };

    return (
        <div className="admin-order-manager">
            <AdminSidebar />
            <h2>주문 관리</h2>
            {newOrderAlert && <div className="order-alert">{orders.length} 건의 새로운 주문이 있습니다!</div>}
            <table className="order-table">
                <thead>
                <tr>
                    <th>주문 번호</th>
                    <th>고객명</th>
                    <th>상품명</th>
                    <th>수량</th>
                    <th>주문 금액</th>
                    <th>주문 방법</th>
                    <th>상태</th>
                    <th>주문일</th>
                </tr>
                </thead>
                <tbody>
                {orders.map((order, idx) => (
                    <tr key={idx}>
                        <td>{order.orderId}</td>
                        <td>{order.buyerName}</td>
                        <td>{order.productName}</td>
                        <td>{order.orderQuantity}</td>
                        <td>{order.totalPrice.toLocaleString()} 원</td>
                        <td>{order.paymentMethod}</td>
                        <td>{order.orderStatus}</td>
                        {/* 주문일은 YYYY-MM-DD HH:mm:ss 형식으로 표시 */}
                         <td>{new Date(order.orderDate).toLocaleString()}</td>
                        {/*<td>{new Date(order.orderDate).toLocaleString()}</td>*/}
                    </tr>
                ))}
                </tbody>
            </table>
        </div>
    );
};

export default AdminOrderManager;
